import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BiqStorageService {
  private readonly COMPLETED_STEPS_KEY = 'user-biq-completed-steps';

  saveCompletedSteps(steps: number[]): void {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem(this.COMPLETED_STEPS_KEY, JSON.stringify(steps));
      }
    } catch (error) {
      console.warn('Failed to save completed steps to localStorage:', error);
    }
  }

  loadCompletedSteps(): number[] {
    try {
      if (typeof localStorage !== 'undefined') {
        const stored = localStorage.getItem(this.COMPLETED_STEPS_KEY);
        return stored ? JSON.parse(stored) : [];
      }
      return [];
    } catch (error) {
      console.warn('Failed to load completed steps from localStorage:', error);
      return [];
    }
  }

  clearCompletedSteps(): void {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(this.COMPLETED_STEPS_KEY);
      }
    } catch (error) {
      console.warn('Failed to clear completed steps from localStorage:', error);
    }
  }
}
